'use client'

import { FormEvent, useState } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { Button } from '@/General/Button'

type ProductPasswordGateProps = {
  hasInvalidSecret: boolean
  internalProductId?: number | null
}

export const ProductPasswordGate = ({
  hasInvalidSecret,
  internalProductId,
}: ProductPasswordGateProps) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [secret, setSecret] = useState('')

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const trimmedSecret = secret.trim()
    if (!trimmedSecret) {
      return
    }

    const params = new URLSearchParams(searchParams.toString())
    params.set('secret', trimmedSecret)
    router.push(`${pathname}?${params.toString()}`)
  }

  return (
    <section className="max-w-3xl mx-auto py-10 px-4">
      <h1 className="text-3xl font-semibold mb-6">Please enter the password</h1>

      <div className="rounded bg-[#f2f2f2] p-5">
        <p className="text-lg text-gray-800 mb-4">
          If you have been given a password to access this page, please enter it
          below.
        </p>

        {hasInvalidSecret && (
          <p className="mb-4 rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            Incorrect access code. Please try again.
          </p>
        )}

        <form onSubmit={onSubmit} className="flex flex-col gap-2 sm:flex-row">
          <input
            type="text"
            value={secret}
            onChange={event => setSecret(event.target.value)}
            placeholder="Password"
            className="w-full rounded border border-gray-300 px-3 py-2 bg-white"
            aria-label="Product access password"
          />
          <Button
            type="submit"
            color="blue"
            size="md"
            className="whitespace-nowrap"
          >
            Submit
          </Button>
        </form>
      </div>

      {internalProductId && (
        <>
          <hr className="my-6 border-gray-200" />
          <p className="text-right text-sm text-gray-500">
            Internal ID: {internalProductId}
          </p>
        </>
      )}
    </section>
  )
}
